fourToldApp.controller('guarantorCntrl', function(esb, services, $scope, $window, $mdDialog, theme, $q, $mdToast, $sce) {
  
  if($window.localStorage.getItem('metadataObj') && $window.localStorage.getItem('metadataObj')!== "undefined")
    var loan_id = JSON.parse($window.localStorage.getItem('metadataObj'));
  $scope.theme =  theme.getTheme();
  $scope.progressCircular = true;
  $scope.toggle = true;
  $scope.pendingGuarantor = [];
  $scope.activeGuarantor = [];
  $scope.historicGuarantor = [];
  $scope.pendingBorrower = [];
  $scope.activeBorrower = [];
  $scope.historicBorrower = [];
  $scope.ui;
  $scope.rejectButtonText= "Rechazar Crédito";
  $scope.acceptButtonText= "Acepto";
  $scope.iconEsb = esb+"/security";
  if(loan_id && loan_id.extra){
    var extra = JSON.parse(loan_id.extra);
    var proposalRequestId = extra.currentProposalId;
    if(extra.ui!=null){
      $scope.ui = extra.ui;
      if(extra.ui.actions){
        $scope.rejectButtonText= extra.ui.actions.reject;
        $scope.acceptButtonText= extra.ui.actions.accept;
      }


    }
  }

  $scope.guarantor_proposal = function(){
    var response = services.guarantors('bearer '+$window.localStorage.getItem('access_token1')).getGuarantorLoanProposals({}, {}, function(response){
      if(response.code === 1){
        $scope.progressCircular = false;
        //$scope.userSelfieBorrower = esb+"/security/"+response.data[0].borrower.userSelfie;
      }
    });
    $q.all([
      response.$promise
    ]).then(function(){
      $scope.guarantor = response.data.find( data => data.proposalRequest.id == proposalRequestId);
      $scope.userSelfieBorrower = esb+"/security/"+$scope.guarantor.borrower.userSelfie;
    }).catch(function (error) {
        console.log(error);
    });
  }

  $scope.guarator_tabs = function(){
    $scope.guarantor_items = services.guarantors('bearer '+$window.localStorage.getItem('access_token1')).getGuarantorLoanProposals({}, {}, function(response){
      $scope.progressCircular = false;
      if(response.code === 1 && response.data[0]){
        $scope.userSelfieBorrower = esb+"/security/"+response.data[0].borrower.userSelfie;
        response.data.forEach(function(item){
          if(item.proposalRequest.status == "PROPOSED" || item.proposalRequest.status == "LINKED"){
            item.status = $scope.get_loan_status(item.loan.status);
            $scope.pendingBorrower.push(item);
          }
          else if(item.proposalRequest.status == "ACCEPTED" && item.loan.status == "ACTIVE" || item.loan.status == "DELAY" || item.loan.status == "61" || item.loan.status == "PROPOSED" || item.loan.status == "ACCEPTED_TELLER_SELECTED" || item.loan.status == "ACCEPTED_TELLER_RESERVED" || item.loan.status == "ACCEPTED"){
            item.status = $scope.get_loan_status(item.loan.status);
            $scope.activeBorrower.push(item);
          } 
          else if(item.proposalRequest.status == "EXPIRED" | item.proposalRequest.status == "REJECTED" | item.proposalRequest.status == "CANCELLED" | item.proposalRequest.status == "ACCEPTED" &&   (item.loan.status == "COMPLETED" | item.loan.status == "REJECTED" | item.loan.status == "REFINANCED" | item.loan.status == "CANCELLED" | item.loan.status == "DEBT_TRANSFER")){
            //item.status = "Finalizado";
            switch (item.proposalRequest.status) {
              case "ACCEPTED":
                  item.status = "Aceptado";
                  break;
                case "REJECTED":
                  item.status = "Rechazado";
                  break;
                case "EXPIRED":
                  item.status = "Expirado";
                  break;
            }      
            $scope.historicBorrower.push(item);
            console.log($scope.historic);
          }
        })
      }
    });
    $scope.guarantor_items = services.guarantors1('bearer '+$window.localStorage.getItem('access_token1')).getGuarantorLoanProposals({}, {}, function(response){
      $scope.progressCircular = false;
      if(response.code === 1 && response.data[0]){
        $scope.userSelfieGuarantor = esb+"/security/"+response.data[0].borrower.userSelfie;
        response.data.forEach(function(item){

          item.guarantor.userSelfie = esb+"/security/"+item.guarantor.userSelfie;
          if(item.proposalRequest.status == "PROPOSED"){
            item.status = $scope.get_loan_status(item.loan.status);
            $scope.pendingGuarantor.push(item);
          }
          else if(item.proposalRequest.status == "ACCEPTED" && item.loan.status == "ACTIVE" || item.loan.status == "DELAY" || item.loan.status == "61" || item.loan.status == "PROPOSED" || item.loan.status == "ACCEPTED_TELLER_SELECTED" || item.loan.status == "ACCEPTED_TELLER_RESERVED" || item.loan.status == "ACCEPTED"){
            item.status = $scope.get_loan_status(item.loan.status);
            $scope.activeGuarantor.push(item);
          }
          else if(item.proposalRequest.status == "EXPIRED" | item.proposalRequest.status == "REJECTED" | item.proposalRequest.status == "CANCELLED" | item.proposalRequest.status == "ACCEPTED" &&   (item.loan.status == "COMPLETED" | item.loan.status == "REJECTED" | item.loan.status == "REFINANCED" | item.loan.status == "CANCELLED" | item.loan.status == "DEBT_TRANSFER")){
            //item.status = "Finalizado";
            switch (item.proposalRequest.status) {
              case "ACCEPTED":
                item.status = "Aceptado";
                break;
              case "REJECTED":
                item.status = "Rechazado";
                break;
              case "EXPIRED":
                item.status = "Expirado";
                break;
            }
            $scope.historicGuarantor.push(item);
            console.log($scope.historic);
          }
        })
      }
    });
  };

  $scope.get_loan_status = function(loanStatus){
    if(loanStatus == "PROPOSED" || loanStatus == "ACCEPTED" || loanStatus == "ACCEPTED_TELLER_SELECTED" || loanStatus == "ACCEPTED_TELLER_RESERVED") {
      return "Pendiente por recoger";
    } else if (loanStatus == "ACTIVE" || loanStatus == "DELAY" || loanStatus == "61" || loanStatus == "REFINANCED") {
      return "Activo";
    } else
      return "Desconocido";
      /*if (item.getLoan() != null && item.getLoan().getLoanDetails() != null) { cuando esta en mora
        if (item.getLoan().getLoanDetails().getTotalDelayInterest() > 0) {
            holder.textviewStatusLoan.setText(mContext.getString(R.string.text_has_arrears));
            holder.textviewStatusLoan.setTextColor(Color.RED);
        }
    }*/
  }

  $scope.getSelfie = function(selfie) {
    return esb+"/security/"+ selfie;
  };

  $scope.getStatus = function(data, loan){
    if(data == "PROPOSED" || data == "ACCEPTED" || data == "ACCEPTED_TELLER_SELECTED" || data == "ACCEPTED_TELLER_RESERVED"){
      $scope.status = "isPending";
      $scope.titleStatus = "Pendiente por recoger";
    }
    else if(data == "ACTIVE" || data == "DELAY" || data == "61" || data == "REFINANCED"){
      $scope.status = "isActive";
      $scope.titleStatus = "Activo";
    }
    else if(loan.proposalRequest.status == "EXPIRED" | loan.proposalRequest.status == "REJECTED" | loan.proposalRequest.status == "CANCELLED" | loan.proposalRequest.status == "ACCEPTED" &&   (data == "COMPLETED" | data == "REJECTED" | data == "REFINANCED" | data == "CANCELLED" | data == "DEBT_TRANSFER")){
      $scope.status = "isHistoric";
      $scope.titleStatus = "Finalizado";
    } else $scope.titleStatus = "Desconocido";
  }

  $scope.details_pending_loan = function(item){
    $scope.data_item_pending = item;
    $scope.show_proposal_details = true;
    $scope.show_historic_details = false;
  }

  $scope.details_historic_loan = function(item){
    $scope.data_item_pending = item;
    $scope.show_historic_details = true;
    $scope.show_proposal_details = false;
  }

  $scope.details_active_loan = function(item){
    $scope.data_item_active = item;
    $scope.show_active_details = true;
  }

  $scope.goBack = function(){
    $scope.show_proposal_details = false;
    $scope.show_historic_details = false;
    $scope.show_active_details = false;
  }

  $scope.periocity = function(data){
    var peridodicity = "";
    switch (data)
    {
      case "WEEKLY":
          peridodicity =  "Semanal";
          break;
      case "TWO_WEEKS":
          peridodicity = "14 días";
          break;
      case "BIWEEKLY":
          peridodicity = "Quincenal";
          break;
      case "MONTHLY":
          peridodicity = "Mensual";
          break;
      case "BIWEEKLY_FIXED":
          peridodicity =  "Mensual";
          break;
    }
    return peridodicity;
  };

  $scope.cancel = function() {
      $mdDialog.cancel();
  };

  $scope.totalLoanFees = function(data){
    $scope.totalFees = 0;
    data.forEach(function(item){
      $scope.totalFees = $scope.totalFees + item.amount;
    });
  }

  $scope.countDelayedPlans = function(data){
    $scope.delayedDays = 0;
    $scope.delayInterest = 0;
    data.plan.forEach(function(item){
      $scope.delayedDays = $scope.delayedDays + item.delayDays;
      $scope.delayInterest = $scope.delayInterest + item.delayInterest;
    });
  }

  $scope.getPercentage = function(data){
    $scope.percentage = ((data.amortizationPlan.totalPaid * 100) / data.totalDue + data.amortizationPlan.totalPaid) / 100;
  }

  $scope.guarantor_response_proposal = function(loanId, response){
    $scope.progressCircular = true;
    var body = {}
    if(extra)
      body = {agaHeader: extra.agaHeader, agaEvent: extra.agaEvent, agaQuery: extra.agaQuery}
    services.guarantors('bearer '+$window.localStorage.getItem('access_token1')).guarantorResponse({loanId: loanId, response: response}, body, function(response){
      if(response.code === 1){
        $scope.progressCircular = false;
        $scope.show_proposal_details = false;
        $scope.cancel();
      }
    });
  }

  $scope.msgToast = function(message, type){
    $mdToast.show(
        $mdToast.simple()
        .textContent(message)
        .position('top')
        .action('Ok')
        .theme(type)
        .hideDelay(2000)
    );
  };

  $scope.renderHtml = function (htmlCode) {
    return $sce.trustAsHtml(htmlCode);
  };

});
